import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { concatMap, Observable } from 'rxjs';
import { AuthState } from 'src/app/store/auth/auth.state';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class HttpBillingInterceptor implements HttpInterceptor {

  constructor(
    private store: Store,
    private auth: AuthService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes(environment.billingApiUrl) && !request.url.includes(environment.integrationsApiUrl)) {
      return next.handle(request);
    }

    const { id } = this.store.selectSnapshot(AuthState.company);
    const params = new HttpParams({ fromString: request.params.toString() })
      .append('tdCompanyId', id)
      .append('deploymentId', environment.deployment);

    return this.auth.scopedTokenStream.pipe(
      concatMap((token) => {
        const clonedRequest = request.clone({
          setHeaders: token ? { Authorization: `Bearer ${token}` } : {},
          params,
        });

        return next.handle(clonedRequest);
      }),
    );
  }
}

export const httpBillingInterceptorProvider = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpBillingInterceptor,
    multi: true,
  },
];
